export default __webpack_public_path__ + "static/gtr-fb20912abc1dfab491402a7ece016d81.png";